export const isIComment = (comment) => typeof comment === 'object' &&
    comment !== null &&
    'coordinates' in comment &&
    'readStatus' in comment;
//# sourceMappingURL=comment.js.map